module.exports = __webpack_public_path__ + "img/money.cafd27d2.gif";